import axios from '@axios'
import i18n from '@/libs/i18n'

export default {
  state: {
    fakeWidgetSettings: {
      showColorInput: false,
      showMainColorInput: false,
      position: 'right',
      lat: 2,
      long: 2,
      animation: 'animation-3',
      buttonColor: '#4b66f8',
      buttonIcon: 'two_lines',
      firstLine: i18n.t('widget.widget'),
      secondLine: `${i18n.t('basic.here')}✌`,
      title: i18n.t('widget.booking-page'),
      rightTab: i18n.tc('basic.specialist', 2),
      leftTab: i18n.t('basic.services'),
      size: 'sidebar-lg',
      show_rating: true,
      mainColor: '#4b66f8',
      currency: { sign: '€', name: 'Euro' },
      calendarType: 2,
    },
    applicationInfo: {
      id: 'cc068464-b73c-43a0-b0ab-47e6baed6b95',
      name: 'NAME OF ORGANIZATION',
      short_name: 'eu',
      short_path: 'eu',
      description: '',
      categories: 'Beauty',
      language: 'en',
      currency: '€',
      currency_code: 'EUR',
      booking_page_url: 'http://localhost:8081/eu',
      logo_url: 'https://media-storage.dev-tobook.link/public-media/organization/cc068464-b73c-43a0-b0ab-47e6baed6b95/logo/117e6a13077a.png',
      map_image_light_url: 'https://storage.googleapis.com/uploads-cdn-tobook-link/organizations/0199b520-76af-73cc-bf2d-9a329886ff21/maps/light/019bdb95d979796298ab95e4ecd13fda.png',
      map_image_dark_url: 'https://storage.googleapis.com/uploads-cdn-tobook-link/organizations/0199b520-76af-73cc-bf2d-9a329886ff21/maps/dark/019bdb95dbbd714496d5620b637c9b43.png',
      email: 'example@gmail.com',
      phone: '+420777891448',
      website: '',
      instagram: '',
      country: 'Germany',
      country_code: 'DE',
      city: 'Hamburg',
      address: 'Berliner Tor',
      timezone: 'Europe/Berlin',
      coordinates: {
        latitude: 53.51403140959429,
        longitude: 9.974191188812258,
      },
      location_url: 'https://www.google.com/maps/place/Berliner Tor/53.51403140959429,53.51403140959429',
      show_rating: true,
      schedule_info: [
        {
          weekday: 0,
          open_at: '09:00:00',
          close_at: '18:00:00',
        },
        {
          weekday: 1,
          open_at: '09:00:00',
          close_at: '18:00:00',
        },
        {
          weekday: 2,
          open_at: '08:00:00',
          close_at: '18:00:00',
        },
        {
          weekday: 3,
          open_at: '08:00:00',
          close_at: '18:00:00',
        },
        {
          weekday: 4,
          open_at: '08:00:00',
          close_at: '18:00:00',
        },
        {
          weekday: 5,
          open_at: null,
          close_at: null,
        },
        {
          weekday: 6,
          open_at: null,
          close_at: null,
        },
      ],
      is_main_office: true,
      mobile_settings: {
        language: 'en',
        name: 'NAME OF ORGANIZATION',
        description: 'Test',
        keywords: 'Keywords, test,',
        button_text: '',
        footer_text: '',
        left_tab_text: 'Services',
        right_tab_text: 'Masters',
        footer_link_text: '',
        icon_url: '',
        background_image_url: '',
        show_tags: false,
        show_rating: false,
        is_map_night_mode_enabled: false,
        android_app_link: '',
        ios_app_link: '',
        colors: {
          primary_color: '#980faf',
          primary_font_color: '#FEFFFF',
          background_primary_color: '#f07bfc',
          background_photo_placeholder_color: '#EBEBEB',
          card_background_color: '#980faf',
          navigation_bar_icon_active_color: '#FFFFFF',
          navigation_bar_icon_inactive_color: '#C7C7C9',
          navigation_bar_background_color: '#e263f6',
        },
      },
    },
    colorsApp: {
      primary_color: '#980faf',
      primary_font_color: '#FEFFFF',
      background_primary_color: '#f07bfc',
      background_photo_placeholder_color: '#EBEBEB',
      card_background_color: '#980faf',
      navigation_bar_icon_active_color: '#FFFFFF',
      navigation_bar_icon_inactive_color: '#C7C7C9',
      navigation_bar_background_color: '#e263f6',
    },
  },
  getters: {
    getFakeWidgetSettings(state) {
      return state.fakeWidgetSettings
    },
    getColors(state) {
      return state.colorsApp
    },
    getApplicationInfo(state) {
      return state.applicationInfo
    },
  },
  mutations: {
    UPDATE_FAKE_WIDGET_SETTINGS(state, { key, value }) {
      state.fakeWidgetSettings[key] = value
    },
    UPDATE_INPUT_COLOR(state, bool) {
      state.fakeWidgetSettings.showColorInput = bool
    },
    UPDATE_INPUT_MAIN_COLOR(state, bool) {
      state.fakeWidgetSettings.showMainColorInput = bool
    },
  },
  actions: {
    sendPartnerEmail(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('email/partner', {
          name: data.name,
          email: data.email,
          message: data.message,
        }).then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sendSupportEmail(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('email/support', data).then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
